module.exports = __webpack_public_path__ + "img/icon-school3.ef68c401.png";